<template>
  <span v-show="cartSize > 0" class="indicator">
    {{ cartSize }}
  </span>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AppIndicator",
  computed: {
    ...mapGetters({
      cartSize: "cart/getCartSize"
    })
  }
};
</script>

<style scoped lang="scss">
.indicator {
  position: absolute;
  top: -2px;
  right: -5px;
  width: 15px;
  height: 15px;
  text-align: center;
  background-color: $group-4-color-1;
  border-radius: 50%;
  font-size: 9px;
  color: $primary-color;

  display: flex;
  justify-content: space-around;
  align-items: center;
  font-family: $fontFamilySecondary;
}
</style>
